var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCooperate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.75,
    fill: "#FEFEFE",
    stroke: "#1C1C1C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1765 48C22.502 48 20.3137 45.8118 20.3137 43.1373V30.9804C20.3137 28.3059 22.502 26.1177 25.1765 26.1177H44.6274C47.302 26.1177 49.4902 28.3059 49.4902 30.9804V43.1373C49.4902 45.8118 47.302 48 44.6274 48H39.7647V55.2941L32.4706 48H25.1765ZM68.9412 62.5883C71.6157 62.5883 73.8039 60.4 73.8039 57.7255V45.5687C73.8039 42.8941 71.6157 40.7059 68.9412 40.7059H54.3529V43.1373C54.3529 48.4863 49.9765 52.8628 44.6274 52.8628V57.7255C44.6274 60.4 46.8157 62.5883 49.4902 62.5883H54.3529V69.8824L61.6471 62.5883H68.9412Z",
    fill: "#1C1C1C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooperate);
export default __webpack_public_path__ + "static/media/Cooperate.4abc5b4475380a199c58350415305372.svg";
export { ForwardRef as ReactComponent };